const PokemonApi = 'https://pokeapi.co/api/v2/';
const PokemonSpritesApi = 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/';

var ServerEnvironmentEnum;
(function (ServerEnvironmentEnum) {
    ServerEnvironmentEnum["LOCAL"] = "LOCAL";
    ServerEnvironmentEnum["TEST"] = "TEST";
    ServerEnvironmentEnum["E2E"] = "E2E";
    ServerEnvironmentEnum["INT"] = "INT";
    ServerEnvironmentEnum["PUBLIC"] = "PUBLIC";
})(ServerEnvironmentEnum || (ServerEnvironmentEnum = {}));

const environment = {
    production: false,
    serverEnvironment: ServerEnvironmentEnum.LOCAL,
    assetsPath: '/assets',
    webEndpoints: {
        pokemonApi: PokemonApi,
        pokemonSpritesApi: PokemonSpritesApi,
        bestPractiseApi: 'http://localhost:3333/best-practise-api/',
        geologApi: 'http://localhost:3333/geolog-api/',
        chatApi: 'http://localhost:3334/chat-api/'
    }
};

/**
 * Generated bundle index. Do not edit.
 */

export { PokemonApi, PokemonSpritesApi, ServerEnvironmentEnum, environment };
